
import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

const state = {
  list: [],
  id: '0',
  code: '',
  display: '',
  position: '',
  name_th: '',
  name_en: '',
  link_manual: {
    th: process.env.MANUAL_URL_TH + '#currency',
    en: process.env.MANUAL_URL_EN + '#currency',
    vi: process.env.MANUAL_URL_VI + '#currency'
  }
}

export default ({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/modules/currencies/index.js